import React, { useState, useEffect } from 'react';

// Inline SVG for the Close (X) icon
const XIcon = ({ className, ...props }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2.5" 
    strokeLinecap="round" 
    strokeLinejoin="round" 
    className={className}
    {...props}
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

// Countdown Timer Component
const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState('');

  useEffect(() => {
    const endDate = new Date('2025-11-30T23:59:59').getTime();

    const interval = setInterval(() => {
      const now = new Date().getTime();
      const t = endDate - now;

      if (t < 0) {
        clearInterval(interval);
        setTimeLeft('Offer Ended');
        return;
      }

      const days = Math.floor(t / (1000 * 60 * 60 * 24));
      const hours = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const mins = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
      const secs = Math.floor((t % (1000 * 60)) / 1000);

      setTimeLeft(`${days} Days | ${hours} Hours | ${mins} Min | ${secs} Sec ⏳`);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="text-inherit text-yellow-200 tracking-wide">
      {timeLeft}
    </div>
  );
};

// Main Popup Component
const PromotionalPopup = ({ onClose, onCtaClick }) => {
  const [isClosing, setIsClosing] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Trigger the enter animation shortly after mount
    const timer = setTimeout(() => setIsVisible(true), 50);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
    }, 300); // Match the duration of the transition
  };

  return (
    <div className={`fixed inset-0 w-full flex items-center justify-center bg-black/70 backdrop-blur-sm z-[999] p-4 py-8 overflow-y-auto max-h-screen transition-opacity duration-300 ease-in-out ${isVisible && !isClosing ? 'opacity-100' : 'opacity-0'}`}>
      <div className={`relative w-full max-w-md md:max-w-lg m-4 transition-all duration-300 ease-in-out ${isVisible && !isClosing ? 'scale-100 opacity-100' : 'scale-95 opacity-0'}`}>
        {/* Close Button */}
        <button 
          onClick={handleClose}
          className="absolute top-4 right-4 z-20 bg-gray-700/50 hover:bg-gray-700/80 p-2 rounded-full text-gray-300 hover:text-white transition-all duration-200"
          aria-label="Close popup"
        >
          <XIcon className="w-6 h-6" />
        </button>

        {/* Popup Content */}
        <div className="flex flex-col justify-center items-center bg-gradient-to-br from-[#0b0b0f] to-[#1a1a1f] rounded-[40px] shadow-2xl shadow-black/60 text-center p-8 md:p-10 py-10 md:py-12 space-y-4 md:space-y-5 overflow-hidden">
          
          <div className="text-2xl md:text-4xl font-bold text-white">
            Early Black Friday Is Live!
          </div>
          
          <div 
            className="text-5xl md:text-7xl font-extrabold text-yellow-400"
            style={{ textShadow: '0 4px 20px rgba(255, 215, 0, 0.3)' }}
          >
            40% OFF
          </div>
          
          <div className="text-base md:text-lg text-gray-200 leading-relaxed">
            On custom website, software & automation solutions.
            <br />
            Book before November 30th!
          </div>
          
          {/* Countdown Timer */}
          <div className="text-2xl font-bold text-yellow-200">
            <CountdownTimer />
          </div>
          
          <button 
            onClick={() => { onCtaClick(); handleClose(); }}
            className="py-3 px-8 md:py-4 md:px-10 text-lg md:text-xl font-bold bg-yellow-400 text-black rounded-full cursor-pointer hover:bg-yellow-300 hover:scale-105 transition-all duration-300 ease-in-out shadow-lg shadow-yellow-400/30">
            Claim Offer Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromotionalPopup;
